module.exports = __webpack_public_path__ + "media/images/checkbox_pink-583d096ae275e7719ed596af412e0bdc.png";